import DoubleArcGauge from "../../../../components/echarts/double-arc-gauge.jsx";

const DutyAttendanceGauge = ({
    data,
    height = "100%",
    title,
    total,
    valueFontSize,
    labelFontSize,
}) => (
    <DoubleArcGauge
        value={data}
        max={total}
        label={title}
        height={height}
        valueFontSize={30}
        labelFontSize={16}
    />
);

export default DutyAttendanceGauge;
